/* Chatnapé : lots, dates de livraison, ajout du produit complémentaire, liste d'avis, ouverture du chat. */
import { CartLinesUpdateEvent } from '@shopify/events';

const euros = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
const prix = (cents) => euros.format(cents / 100);

function formulaire(el) {
  const sec = el.closest('.shopify-section') || document;
  return sec.querySelector('form[data-type="add-to-cart-form"]');
}

/* ---------- Lots (1, 2 ou 3 articles) ---------- */
const memoire = {};
class CnLots extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"]')) {
        this.dataset.qte = e.target.value;
        memoire[this.dataset.bloc] = e.target.value;
        this.appliquer();
      }
    });
    if (memoire[this.dataset.bloc]) {
      this.dataset.qte = memoire[this.dataset.bloc];
    } else if (!this.dataset.qte) {
      const coche = this.querySelector('input[type="radio"]:checked');
      this.dataset.qte = coche ? coche.value : '1';
    }
    this.rafraichir();
    this.appliquer();
  }

  get donnees() {
    try {
      return JSON.parse(this.querySelector('script[data-cn-prix]').textContent);
    } catch (e) {
      return {};
    }
  }

  varianteCourante() {
    const f = formulaire(this);
    const champ = f && f.querySelector('input[name="id"]');
    return champ ? champ.value : null;
  }

  rafraichir() {
    const prixVariantes = this.donnees;
    const id = this.varianteCourante();
    const unitaire = prixVariantes[id];
    if (unitaire === undefined) return;
    const seuil = Number(this.dataset.seuil);
    const frais = Number(this.dataset.frais);
    this.querySelectorAll('.cn-lot').forEach((lot) => {
      const q = Number(lot.dataset.q);
      const r = Number(lot.dataset.r);
      const brut = unitaire * q;
      /* Même calcul que Shopify : remise appliquée sur le prix unitaire, arrondi au centime. */
      const net = q * Math.round((unitaire * (100 - r)) / 100);
      const elNet = lot.querySelector('[data-cn-net]');
      const elBrut = lot.querySelector('[data-cn-brut]');
      const elLiv = lot.querySelector('[data-cn-liv]');
      if (elNet) elNet.textContent = prix(net);
      if (elBrut) elBrut.textContent = prix(brut);
      if (elLiv) elLiv.textContent = net >= seuil ? 'Livraison offerte.' : `+ ${prix(frais)} de livraison.`;
    });
    const choisi = this.querySelector(`input[value="${this.dataset.qte}"]`);
    if (choisi && !choisi.checked) choisi.checked = true;
  }

  appliquer() {
    const f = formulaire(this);
    if (!f) return;
    const champ = f.querySelector('input[name="quantity"]');
    if (champ) champ.value = this.dataset.qte || '1';
  }
}
if (!customElements.get('cn-lots')) customElements.define('cn-lots', CnLots);

/* La quantité choisie est réappliquée juste avant chaque ajout au panier. */
document.addEventListener(
  'submit',
  (e) => {
    const f = e.target;
    if (!(f instanceof HTMLFormElement) || f.dataset.type !== 'add-to-cart-form') return;
    const sec = f.closest('.shopify-section');
    const lots = sec && sec.querySelector('cn-lots');
    if (lots) lots.appliquer();
  },
  true
);

/* Après un changement de taille ou de couleur, les prix des lots suivent. */
document.addEventListener('change', (e) => {
  if (!e.target.closest || !e.target.closest('variant-picker')) return;
  const sec = e.target.closest('.shopify-section');
  const lots = sec && sec.querySelector('cn-lots');
  if (!lots) return;
  [80, 400, 1000, 2000].forEach((t) => setTimeout(() => { lots.rafraichir(); lots.appliquer(); }, t));
});

/* ---------- Dates de livraison ---------- */
const nomMois = new Intl.DateTimeFormat('fr-FR', { month: 'long' });
/* « 1er » pour le premier du mois, comme on l'écrit en français. */
const jour = (d) => (d.getDate() === 1 ? '1er' : String(d.getDate()));
const jourMois = (d) => `${jour(d)} ${nomMois.format(d)}`;
function dates() {
  document.querySelectorAll('[data-cn-livraison]').forEach((el) => {
    const min = Number(el.dataset.min);
    const max = Number(el.dataset.max);
    if (!min || !max) return;
    const a = new Date();
    a.setDate(a.getDate() + min);
    const b = new Date();
    b.setDate(b.getDate() + max);
    const debut = a.getMonth() === b.getMonth() ? jour(a) : jourMois(a);
    el.textContent = `prévue entre le ${debut} et le ${jourMois(b)}`;
  });
}

/* ---------- Ajout du produit complémentaire ---------- */
function lignesDuKit(bouton) {
  const choix = bouton.closest('[data-cn-kit]')?.querySelector('input[type="radio"]:checked');
  try {
    return JSON.parse(choix.dataset.lignes).map((l) => ({ id: String(l.id), q: Number(l.q) }));
  } catch (e) {
    return null;
  }
}

async function ajouter(bouton) {
  /* Un kit ajoute plusieurs lignes (un produit = une ligne) ; sinon une seule variante. */
  const kit = bouton.hasAttribute('data-cn-kit-btn') ? lignesDuKit(bouton) : null;
  const id = kit ? kit[0].id : bouton.dataset.variantId;
  const qte = kit ? kit.reduce((t, l) => t + l.q, 0) : Number(bouton.dataset.qte || 1);
  if (!id || bouton.disabled) return;
  bouton.disabled = true;
  const texte = bouton.textContent;
  /* Dans le panier, le bloc est redessiné après l'ajout : on ne touche pas au texte. */
  const dansPanier = Boolean(bouton.closest('.cn-panier-plus'));
  let message = '';
  const sections = [...document.querySelectorAll('cart-items-component')]
    .map((c) => c.dataset.sectionId)
    .filter(Boolean)
    .join(',');
  const attente = CartLinesUpdateEvent.createPromise();
  bouton.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: kit ? kit.map((l) => ({ merchandiseId: l.id, quantity: l.q })) : [{ merchandiseId: id, quantity: qte }],
      promise: attente.promise,
    })
  );
  const corps = new FormData();
  corps.append('id', id);
  corps.append('quantity', String(qte));
  if (sections) corps.append('sections', sections);
  try {
    const rep = kit
      ? await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: kit.map((l) => ({ id: Number(l.id), quantity: l.q })),
            ...(sections ? { sections } : {}),
          }),
        }).then((r) => r.json())
      : await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: corps,
        }).then((r) => r.json());
    const panier = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    attente.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(panier),
      detail: {
        items: panier.items,
        source: 'cn-complement',
        sourceId: 'cn-complement',
        itemCount: qte,
        sections: rep.sections,
        didError: Boolean(rep.status),
      },
    });
    message = rep.status ? 'Ajout impossible, réessayez' : 'Ajouté au panier';
  } catch (err) {
    attente.reject(err);
    message = 'Ajout impossible, réessayez';
  }
  if (dansPanier) {
    bouton.disabled = false;
    return;
  }
  bouton.textContent = message;
  setTimeout(() => {
    if (bouton.textContent === message) bouton.textContent = texte;
    bouton.disabled = false;
  }, 3000);
}
document.addEventListener('click', (e) => {
  const b = e.target.closest && e.target.closest('[data-cn-ajouter]');
  if (b) {
    e.preventDefault();
    ajouter(b);
  }
});

/* ---------- Kit : prix selon le coloris choisi ---------- */
document.addEventListener('change', (e) => {
  const r = e.target.closest && e.target.closest('[data-cn-kit] input[type="radio"]');
  if (!r) return;
  const bloc = r.closest('[data-cn-kit]');
  const net = bloc.querySelector('[data-cn-kit-net]');
  const brut = bloc.querySelector('[data-cn-kit-brut]');
  if (net && r.dataset.net) net.textContent = r.dataset.net;
  if (brut && r.dataset.brut) brut.textContent = r.dataset.brut;
});

/* ---------- Liste d'avis : afficher la suite ---------- */
document.addEventListener('click', (e) => {
  const b = e.target.closest && e.target.closest('[data-cn-plus]');
  if (!b) return;
  const liste = document.getElementById(b.getAttribute('aria-controls'));
  if (!liste) return;
  const caches = [...liste.querySelectorAll('.cn-avis[hidden]')];
  const lot = Number(b.dataset.cnPlus) || 10;
  caches.slice(0, lot).forEach((a, i) => {
    a.hidden = false;
    if (i === 0) {
      a.setAttribute('tabindex', '-1');
      a.focus({ preventScroll: true });
    }
  });
  const reste = caches.length - lot;
  if (reste <= 0) b.remove();
  else b.textContent = `Voir ${Math.min(lot, reste)} avis de plus (${reste} restants)`;
});

/* ---------- Liens « Écrivez-nous » : ouvrent le chat de la boutique s'il est présent ---------- */
document.addEventListener('click', async (e) => {
  const a = e.target.closest && e.target.closest('a[data-cn-ouvrir-chat]');
  if (!a) return;
  const chat = document.querySelector('shopify-chat');
  if (!chat || !customElements.get('shopify-chat')) return;
  e.preventDefault();
  let hote = a.closest('dialog');
  while (hote && typeof hote.closeDialog !== 'function') hote = hote.parentElement;
  if (hote) await hote.closeDialog();
  if (typeof chat.show === 'function') chat.show();
  else chat.setAttribute('open', '');
});

dates();
document.addEventListener('shopify:section:load', dates);
